export const API_KEY_GET_MANAGEABLE_NOTIFICATIONS =
  "API_KEY_GET_MANAGEABLE_NOTIFICATIONS";
export const API_KEY_GET_MANAGEABLE_NOTIFICATION =
  "API_KEY_GET_MANAGEABLE_NOTIFICATION";
